import { ApolloCache, useApolloClient } from "@apollo/client";

export const useApolloCache = () => {
  const client = useApolloClient();
  return {
    clearRiseAction: (id: string) => clearRiseAction(client.cache, id),
  };
};

export const clearRiseAction = (cache: ApolloCache<object>, id: string) => {
  cache.evict({
    id: cache.identify({
      id,
      __typename: "RiseUserAction",
    }),
  });
};
